<div class="course-settings">
  <div class="course-settings__content">
    @if (layoutVariant() === 'school') {
      <app-upload-media (dataChange)="onUploadMediaChange($event)"></app-upload-media>
    }

    <div class="settings-box">
      <div class="settings-box__container">
        <div class="settings-box__header">
          <div class="settings-box__title">{{ 'app.components.courseCreator.settings.settingsBox.title' | translate }}
          </div>
        </div>

        <app-recommendations-box></app-recommendations-box>
        <app-main-info
          [showTopic]="layoutVariant() === 'admin'"
          (dataChange)="onMainInfoChange($event)"
        ></app-main-info>
        <app-structure (dataChange)="onStructureChange($event)"></app-structure>
        @if (layoutVariant() === 'admin') {
          <app-video-heroes-settings
            (dataChange)="onVideoHeroesChange($event)"
          ></app-video-heroes-settings>
        }
      </div>
    </div>

    <app-cta-button variant="light" size="small" (clicked)="onComplete()">
      <span cta-prefix>
        <img src="public/svgs/ai-w.svg" alt="AI" />
      </span>
      <span cta-label>{{ 'app.components.courseCreator.settings.continue' | translate }}</span>
    </app-cta-button>
  </div>
</div>